import "./PageHeader.scss";
import { Link } from "react-router-dom";
import { Component } from "react";
import logo from "../../assets/Logo/InStock-Logo_2x.png";

class PageHeader extends Component {
  render() {
    return (
      <div className="wrapper">
        <header className="nav-bar">
          <Link className="nav-bar-link" to="/warehouse">
            <img className="nav-bar-link__logo" src={logo} alt="InStock Logo" />
          </Link>
          <ul className="nav-bar-list">
            <Link
              className={
                this.props.location.pathname.includes("warehouse")
                  ? "nav-bar-list-link nav-bar-list-link--highlight"
                  : "nav-bar-list-link"
              }
              to="/warehouse"
            >
              <li className="nav-bar-list-link__item">Warehouses</li>
            </Link>
            <Link
              className={
                this.props.location.pathname.includes("inventory")
                  ? "nav-bar-list-link nav-bar-list-link--highlight"
                  : "nav-bar-list-link"
              }
              to="/inventory"
            >
              <li className="nav-bar-list-link__item">Inventory</li>
            </Link>
          </ul>
        </header>
      </div>
    );
  }
}
export default PageHeader;
